import { koliCount, koliPairs, koliText } from "@/lib/api";
import { useData } from "@/lib/data";
import { Input } from "@/components/ui/input";
import KoliTypeSelect from "@/components/KoliTypeSelect";
import { Package } from "lucide-react";

export default function KoliPanel({ items, stockOf, koliMap, onKoliChange, koliType, onKoliTypeChange }) {
  const { productById } = useData();
  const ratios = koliType?.ratios || {};
  const productIds = [...new Set(items.filter((it) => it.qty - (it.shipped_qty || 0) > 0).map((it) => it.product_id))];

  const maxKoliFor = (pid) => {
    const avail = {};
    items.filter((it) => it.product_id === pid).forEach((it) => {
      avail[it.size] = Math.min(it.qty - (it.shipped_qty || 0), stockOf(it));
    });
    return koliCount(avail, ratios);
  };

  return (
    <div className="rounded-md border border-[#D97706]/40 bg-[#EFE6D6] p-4 mb-4" data-testid="koli-panel">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-3">
        <span className="flex items-center gap-2 font-display uppercase tracking-wide text-[#B45309]">
          <Package className="w-4 h-4" /> Koli ile Sevk
        </span>
        <div className="flex items-center gap-2 sm:w-[420px]">
          <KoliTypeSelect value={koliType?.id || ""} onChange={onKoliTypeChange} testId="shipment-koli-type" className="flex-1" />
        </div>
      </div>
      <p className="text-[11px] font-mono text-[#6B5B4A] mb-2">1 koli = {koliText(ratios)} = {koliPairs(ratios)} çift</p>
      <div className="space-y-2">
        {productIds.map((pid) => {
          const p = productById(pid);
          const max = maxKoliFor(pid);
          return (
            <div key={pid} className="flex flex-wrap items-center justify-between gap-3 border-t border-[#DCCFB8] pt-2" data-testid={`koli-row-${pid}`}>
              <span className="text-sm">
                <b className="font-mono text-[#B45309]">{p?.model_code || "—"}</b> · {p?.model_color}
                <span className="text-[11px] font-mono text-[#8C7B68] ml-2" data-testid={`koli-max-${pid}`}>en fazla {max} koli</span>
              </span>
              <div className="flex items-center gap-2">
                <Input type="number" min={0} max={max} inputMode="numeric" data-testid={`koli-input-${pid}`}
                  value={koliMap[pid] ?? ""} placeholder="0"
                  onChange={(e) => {
                    const v = e.target.value === "" ? "" : Math.max(0, Math.min(max, parseInt(e.target.value) || 0));
                    onKoliChange(pid, v);
                  }}
                  className="zs-size-input text-center h-10 w-24 bg-[#FFFBF4] border-[#DCCFB8]" />
                <span className="text-xs font-mono text-[#6B5B4A] whitespace-nowrap">koli = {(parseInt(koliMap[pid]) || 0) * koliPairs(ratios)} çift</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
